import { Card } from '../design-system/Card';
import { Text } from '../design-system/Text';

interface NudgeAnnotation {
  intent: string;
  why: string;
  pros: string[];
  cons: string[];
  expected: string;
  risk: string;
  experiment: string;
  verdict: 'accepted' | 'rejected' | 'default';
}

interface NudgeAnnotationCardProps {
  title: string;
  annotation: NudgeAnnotation;
}

export function NudgeAnnotationCard({ title, annotation }: NudgeAnnotationCardProps) {
  return (
    <Card padding="md" elevation={1}>
      <div className="mb-2 flex items-center gap-2">
        <Text variant="body-medium">{title}</Text>
        <span
          className={`rounded-full px-2 py-0.5 text-xs font-medium ${
            annotation.verdict === 'default'
              ? 'bg-park-100 text-park-700 dark:bg-park-900/30 dark:text-park-300'
              : annotation.verdict === 'accepted'
              ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
              : 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
          }`}
        >
          {annotation.verdict}
        </span>
      </div>

      <Field label="Intent">{annotation.intent}</Field>
      <Field label="Why it exists">{annotation.why}</Field>
      <Field label="Expected behavior">{annotation.expected}</Field>
      <Field label="Risk to challan conversion">{annotation.risk}</Field>
      <Field label="Recommended experiment">{annotation.experiment}</Field>

      <div className="mt-3 grid grid-cols-2 gap-3">
        <div>
          <Text variant="caption" color="secondary">Pros</Text>
          <ul className="mt-1 list-disc space-y-1 pl-4 text-xs text-slate-700 dark:text-slate-300">
            {annotation.pros.map((p, i) => (
              <li key={i}>{p}</li>
            ))}
          </ul>
        </div>
        <div>
          <Text variant="caption" color="secondary">Cons</Text>
          <ul className="mt-1 list-disc space-y-1 pl-4 text-xs text-slate-700 dark:text-slate-300">
            {annotation.cons.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="mt-2">
      <Text variant="caption" color="secondary">{label}</Text>
      <Text variant="body" color="secondary">{children}</Text>
    </div>
  );
}
